import isElement from "lodash.iselement";
import fetchProductData from "../api/fetchProductData.js";
import {
  dom,
  updateTextContent,
  updateAttrs,
  updateDataset,
  updateValue,
  mapActiveClass
} from "../helpers/dom.js";
import FullBreadcrumbs from "./fullBreadcrumbs.js";
import FullQuantity from "./fullQuantity.js";
import FullSizes from "./fullSizes.js";
import FullGallery from "./fullGallery.js";
import FullThumbs from "./fullThumbs.js";
import FullClose from "./fullClose.js";

class Full {
  constructor(props) {
    this.id = props.id;
    this.isAuthorized = props.isAuthorized;
    if (!this.id) return;
    // After data fetch
    const onResponse = data => {
      const fetchedProps = this._mapFetchedToProps(data);
      this.props = Object.assign({}, props, fetchedProps);
      this.init(this.props);
    };
    fetchProductData(props.id, props.size || "", onResponse);
    // Get callbacks
    this._onSizeChange = props.onSizeChange || (() => {});
    this._onQuantityChange = props.onQuantityChange || (() => {});
    this._onBuy = props.onBuy || (() => {});
  }
  init(props) {
    // Create components
    this._breadcrumbs = new FullBreadcrumbs({
      onClick: this.close.bind(this)
    });
    this._quantity = new FullQuantity({
      initialValue: props.quantity,
      limit: props.available,
      onChange: props.onQuantityChange || (() => {})
    });
    this._sizes = new FullSizes({
      sizes: props.sizes || [],
      current: props.size || null,
      onChange: this.changeSize.bind(this)
    });
    this._gallery = new FullGallery(props.images);
    this._thumbs = new FullThumbs(props.images, {
      onClick: index => this._gallery.setActive(index)
    });
    this._closeButton = new FullClose({ onClick: this.close.bind(this) });

    // Make dom
    this.modal = dom("div.b-modal", {}, [this._makeDom()]);
    document.body.appendChild(this.modal);

    // Show modal window
    this.modal.classList.add("b-modal--active");

    // Hide page
    const page = document.querySelector(".page");
    if (isElement(page)) {
      page.classList.add("hidden");
    }

    // Scroll to top
    if (app && app.isMobile) {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }

    // Add hash
    window.location.hash = `product_${this.id}`;

    // Initialize widgets
    this._quantity.initWidget();
    this._gallery.initWidget();

    // Close on overlay click
    this.modal.addEventListener("click", e => {
      if (e.target === this.modal) {
        this.close();
      }
    });

    // Add event listener for buy button
    const buyButton = this.modal.querySelector(".buy");
    if (isElement(buyButton)) {
      buyButton.addEventListener("click", () => this._onBuy());
    }
  }
  close() {
    // Show page
    const page = document.querySelector(".page");
    if (isElement(page)) {
      page.classList.remove("hidden");
    }
    // Clear hash
    const savedScroll = {
      html: document.documentElement.scrollTop,
      body: document.body.scrollTop
    };
    window.location.hash = "";
    document.documentElement.scrollTop = savedScroll.html;
    document.body.scrollTop = savedScroll.body;

    this.modal.parentElement.removeChild(this.modal);
  }
  changeSize(value) {
    fetchProductData(this.props.id, value, this._update.bind(this));
    this._sizes.setActive(value);
    this._onSizeChange(value);
  }
  _makeDom() {
    let controls = dom("div.full__controls", {}, "");
    if (this.isAuthorized) {
      controls = dom("div.full__controls", {}, [
        dom("div.full__price", {}, [
          dom("div.price.price--full", {}, [
            dom("div.price__real", {}, `${this.props.realPrice} ₽` || ""),
            dom(
              "div.price__old",
              {},
              this.props.oldPrice ? `${this.props.oldPrice} ₽` : ""
            )
          ])
        ]),
        this.props.sizes.length > 0 &&
          dom("div.full__sizes", {}, [
            dom("div.full__label", {}, "Размер"),
            this._sizes.init()
          ]),
        dom("div.full__quantity", {}, [
          dom("div.full__label", {}, "Количество"),
          dom("div.full__row", {}, [
            this._quantity.init(),
            dom("button.buy.buy--full", {}, "В корзину")
          ])
        ]),
        dom("div.full__available", {}, [
          dom("div.available", {}, `Доступно - ${this.props.available} шт.`)
        ])
      ]);
    }
    let infoItems = [];

    if (this.props.code && this.props.code.length > 0) {
      const item = dom("div.full__code", {}, [
        dom("div.full__label", {}, "Код товара:"),
        dom("div.full__value", {}, this.props.code)
      ]);
      infoItems.push(item);
    }

    if (this.props.barcode && this.props.barcode.length > 0) {
      const item = dom("div.full__barcode", {}, [
        dom("div.full__label", {}, "Штрихкод:"),
        dom("div.full__value", {}, this.props.barcode)
      ]);
      infoItems.push(item);
    }

    if (this.props.country && this.props.country.length > 0) {
      const item = dom("div.full__country", {}, [
        dom("div.full__label", {}, "Страна:"),
        dom("div.full__value", {}, this.props.country)
      ]);
      infoItems.push(item);
    }

    if (this.props.manufacturer && this.props.manufacturer.length > 0) {
      const item = dom("div.full__manufacturer", {}, [
        dom("div.full__label", {}, "Производитель:"),
        dom("div.full__value", {}, this.props.manufacturer)
      ]);
      infoItems.push(item);
    }

    if (this.props.brand && this.props.brand.length > 0) {
      const item = dom("div.full__brand", {}, [
        dom("div.full__label", {}, "Бренд:"),
        dom("div.full__value", {}, this.props.brand)
      ]);
      infoItems.push(item);
    }

    if (this.props.productioncode && this.props.productioncode.length > 0) {
      const item = dom("div.full__productioncode", {}, [
        dom("div.full__label", {}, "Код производителя:"),
        dom("div.full__value", {}, this.props.productioncode)
      ]);
      infoItems.push(item);
    }

    if (this.props.boxtype && this.props.boxtype.length > 0) {
      const item = dom("div.full__boxtype", {}, [
        dom("div.full__label", {}, "Вид упаковки:"),
        dom("div.full__value", {}, this.props.boxtype)
      ]);
      infoItems.push(item);
    }

    if (this.props.material && this.props.material.length > 0) {
      const item = dom("div.full__material", {}, [
        dom("div.full__label", {}, "Материал:"),
        dom("div.full__value", {}, this.props.material)
      ]);
      infoItems.push(item);
    }

    if (this.props.vibration && this.props.vibration.length > 0) {
      const item = dom("div.full__vibration", {}, [
        dom("div.full__label", {}, "Вибрация:"),
        dom("div.full__value", {}, this.props.vibration)
      ]);
      infoItems.push(item);
    }

    if (this.props.color && this.props.color.length > 0) {
      const item = dom("div.full__color", {}, [
        dom("div.full__label", {}, "Цвет:"),
        dom("div.full__value", {}, this.props.color)
      ]);
      infoItems.push(item);
    }

    if (this.props.size && this.props.size.length > 0) {
      const item = dom("div.full__size", {}, [
        dom("div.full__label", {}, "Размер:"),
        dom("div.full__value", {}, this.props.size)
      ]);
      infoItems.push(item);
    }

    if (this.props.volume && this.props.volume.length > 0) {
      const item = dom("div.full__volume", {}, [
        dom("div.full__label", {}, "Объём, мл:"),
        dom("div.full__value", {}, this.props.volume)
      ]);
      infoItems.push(item);
    }

    if (this.props.diameter && this.props.diameter.length > 0) {
      const item = dom("div.full__diameter", {}, [
        dom("div.full__label", {}, "Диаметр:"),
        dom("div.full__value", {}, this.props.diameter)
      ]);
      infoItems.push(item);
    }

    if (this.props.battery && this.props.battery.length > 0) {
      const item = dom("div.full__battery", {}, [
        dom("div.full__label", {}, "Элементы питания:"),
        dom("div.full__value", {}, this.props.battery)
      ]);
      infoItems.push(item);
    }

    if (this.props.weight && this.props.weight.length > 0) {
      const item = dom("div.full__weight", {}, [
        dom("div.full__label", {}, "Вес брутто:"),
        dom("div.full__value", {}, this.props.weight)
      ]);
      infoItems.push(item);
    }

    if (this.props.desc && this.props.desc.length > 0) {
      const item = dom("div.full__desc", {}, [
        dom("div.full__label", {}, "Описание:"),
        dom("div.full__value", {}, this.props.desc)
      ]);
      infoItems.push(item);
    }

    const info = dom("div.full__info", {}, infoItems);
    return dom("div.full", {}, [
      dom("div.full__back", {}, [this._breadcrumbs.init()]),
      dom("div.full__images", {}, [this._gallery.init()]),
      this._thumbs.init(),
      dom("div.full__wrapper", {}, [
        dom("div.full__title", {}, this.props.name || ""),
        dom("div.full__content", {}, [controls, info])
      ]),
      dom("div.full__close", {}, [this._closeButton.init()])
    ]);
  }
  _update(data) {
    // Set title
    updateTextContent(this.modal, ".full__title", data.pagetitle);
    // Set product code
    updateTextContent(this.modal, ".full__code .full__value", data.code);
    // Set product barcode
    updateTextContent(this.modal, ".full__barcode .full__value", data.ean);
    // Set price
    updateTextContent(this.modal, ".price__real", `${data.price} ₽`);
    updateTextContent(
      this.modal,
      ".price__old",
      data.old_price ? `${data.old_price} ₽` : ""
    );
    // Set available
    updateTextContent(
      this.modal,
      ".available",
      `Доступно - ${data.quantity} шт.`
    );
    // Set hidden input value
    updateValue(this.modal, "input[name=id]", data.id);
    // Update quantity widget limit
    if (this._quantity) {
      this._quantity.updateLimit(data.quantity);
    }
  }
  _mapFetchedToProps(fetched) {
    return {
      id: fetched.id || 0,
      name: fetched.pagetitle || "",
      available: fetched.quantity || 0,
      realPrice: fetched.price || 0,
      oldPrice: fetched.old_price || 0,
      code: fetched.code || "",
      barcode: fetched.ean || "",
      country: fetched.country || "",
      manufacturer: fetched.manufacturer || "",
      brand: fetched.vendor || "",
      productioncode: fetched.productioncode || "",
      boxtype: fetched.boxtype || "",
      material: fetched.material || "",
      vibration: fetched.vibration || "",
      color: fetched.color || "",
      volume: fetched.volume || "",
      diameter: fetched.diameter || "",
      battery: fetched.battery || "",
      weightbr: fetched.weightbr || "",
      desc: fetched.content || "",
      sizes: fetched.size || [],
      images: [fetched.photo1, fetched.photo2, fetched.photo3]
    };
  }
}

export default Full;



// WEBPACK FOOTER //
// ./src/js/components/full.js